import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var OptionValuesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default OptionValuesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/OptionValues/OptionValuesReduxProps.ts
// module id = 385
// module chunks = 0